import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	logo: {
		alignItems: "center",
		display: "none",
		flexDirection: "column",
		gap: 12,
		justifyContent: "center",
		maxWidth: 120,
		[theme.breakpoints.up("md")]: {
			display: "flex"
		},
		"& p": {
			fontSize: 14,
			textAlign: "center",
			textWrap: "balance"
		}
	}
}));

export default styles;
